import { __assign } from "tslib";
import classNames from 'classnames';
import React from 'react';
import styles from './kebab-menu.module.css';
import MenuList from '../menu-list/menu-list';
export function KebabMenu(props) {
    return (React.createElement(MenuList, __assign({}, props), function (_a) {
        var _b;
        var openMenu = _a.openMenu, isOpen = _a.isOpen, setButtonRef = _a.setButtonRef;
        return (React.createElement("button", { className: classNames(styles.kebabMenuButton, (_b = {}, _b[styles.active] = isOpen, _b), "kplr_kebabMenuButton"), type: "button", ref: setButtonRef, onClick: function () { return openMenu(); } },
            React.createElement("svg", { fill: "none", viewBox: "0 0 5 19" },
                React.createElement("path", { d: "M2.98047 11.5023c1.10457 0 2-.8954 2-1.99998 0-1.10457-.89543-2-2-2s-2.000001.89543-2.000001 2c0 1.10458.895431 1.99998 2.000001 1.99998ZM2.98047 4.50232c1.10457 0 2-.89543 2-2s-.89543-2.000001-2-2.000001S.980469 1.39775.980469 2.50232c0 1.10457.895431 2 2.000001 2ZM2.98047 18.5023c1.10457 0 2-.8954 2-2s-.89543-2-2-2-2.000001.8954-2.000001 2 .895431 2 2.000001 2Z" }))));
    }));
}
export default KebabMenu;
